import { defineComponent as _defineComponent } from 'vue'
import { defaultErrorHandler } from '@/admin-shared-modules/utils'
import { MessageService } from '@/admin-shared-modules/utils/message.service'
import moment from 'moment'
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router/composables'
import Draggable from 'vuedraggable'
import { useUpload } from '../useUpload'
import { BuildInAPPs, useCustomApps } from './app'
import { DevicesOfTemplate, useStore } from './store'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

moment.locale('zh-cn')

const router = useRouter()

const date = ref(moment().format('YYYY年MM月DD日 dddd'))

const store = useStore()

//
// Designer
//
const sections = computed(() => store.data.value.sections as any[])

function removeSection(index: number) {
  store.data.value.sections.splice(index, 1)
}

function addSection(columns = 1) {
  store.data.value.sections.push({
    type: 'apps',
    name: '模块名称',
    columns,
    data: []
  })
}

//
// From
//

const currentIndex = ref<number>()

const formData = computed(() => {
  if (currentIndex.value === undefined) return
  return store.data.value.sections[currentIndex.value] as any
})

// banner
const uploadProps = useUpload({
  onUpload(url) {
    formData.value.images.push(url)
  }
})

function removeBannerImage(index: number) {
  formData.value.images.splice(index, 1)
}

// app section
function removeApp(index: number) {
  formData.value.data.splice(index, 1)
}

const appAliasEditIndex = ref<number>()
const appAliasInputValue = ref('')
function onEditAppAlias(index: number) {
  appAliasEditIndex.value = index
  const data = formData.value.data[index]
  appAliasInputValue.value = data.alias || data.name
}
function onAliasSubmit() {
  const value = appAliasInputValue.value.trim()
  const data = formData.value.data[appAliasEditIndex.value]
  if (data.name !== value) {
    data.alias = value
  } else {
    data.alias = ''
  }
  appAliasEditIndex.value = undefined
}

// app
const appSelectDialogVisible = ref(false)
const appSelectTab = ref('1')

const buildInAppsFromLOSApps = computed(() => {
  return BuildInAPPs.filter(it => {
    if (it.type !== 'libApp') {
      return false
    }
    return true
  })
})

const buildInAppsFromLOSResource = computed(() => {
  const items = BuildInAPPs.filter(it => {
    if (it.type !== 'libResource') {
      return false
    }
    return true
  })
  return items
})

const {
  loading: customAppsLoading,
  data: customApps,
  fetch: fetchCustomApps
} = useCustomApps()
const selected = ref()

watch(
  appSelectTab,
  () => {
    selected.value = []
    if (appSelectTab.value === '3') {
      fetchCustomApps()
    }
  },
  {
    immediate: true
  }
)

function handleSelectChange(rows) {
  selected.value = rows
}

function checkSelectable(row) {
  return true
}

function formCommit() {
  const count = selected.value.length + formData.value.data.length
  const max = formData.value.columns === 1 ? 3 : 7

  if (count > max) {
    MessageService.open({
      type: 'warning',
      message: `最多只能添加${max}个应用`
    })
    return
  }

  const apps = selected.value.map(it => {
    return {
      ...it
    }
  })

  formData.value.data.push(...apps)
  appSelectDialogVisible.value = false
}

const isSubmitting = ref(false)

function submit() {
  try {
    isSubmitting.value = true
    store.submit()
    MessageService.open({
      type: 'success',
      message: '保存成功'
    })
  } catch (e) {
    defaultErrorHandler(e)
  } finally {
    isSubmitting.value = false
  }
}

return { __sfc: true,router, date, store, sections, removeSection, addSection, currentIndex, formData, uploadProps, removeBannerImage, removeApp, appAliasEditIndex, appAliasInputValue, onEditAppAlias, onAliasSubmit, appSelectDialogVisible, appSelectTab, buildInAppsFromLOSApps, buildInAppsFromLOSResource, customAppsLoading, customApps, fetchCustomApps, selected, handleSelectChange, checkSelectable, formCommit, isSubmitting, submit, Draggable, DevicesOfTemplate }
}

})